import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
@Component({
  selector: 'common-product-card-view-loader',
  templateUrl: './common-product-card-view-loader.component.html',
  styleUrls: [
    './common-product-card-view-loader.component.scss'
  ],
})
export class CommonProductCardViewLoaderComponent implements OnInit {
  constructor() {

  }

  @Input() total: number = 2;
  items: number[] = Array.from({ length: this.total }, (_, i) => i);

  ngOnInit(): void {

  }
}
